import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Form, Col } from 'antd';

import history from 'utils/history';

import RichEditor from 'components/RichEditor';
// utils
import { useRefState } from 'utils/hooks';

function RichEditorField({
  form,
  data,
  mode,
  index,
  method,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'dynamic-multiple-select-column', className);

  const newKey = 'nouvel';
  const onlyRead = mode == 'onlyRead' && data?.hasModeView;
  const isEdit = mode == 'edit' || mode == 'new';
  const cameFrom = history.location?.state?.from;

  const [currentValue, currentValueRef, setCurrentValue] = useRefState(
    (method != newKey && !!!cameFrom || cameFrom == 'preview_communication') ? (
      form.getFieldValue(data?.hiddenChain) || form.getFieldValue(data?.name) || data?.value || ''
    ) : ''
  );

  const customChainRule = async (rule, value, callback) => {
    const initVal = form.getFieldsValue();
    const chainVal = initVal?.[(data?.hiddenChain)] || '';
    const isValid = !!chainVal || false;
    const regex = /<[^>]*>|^\s*$/gm; // match any HTML tags and whitespace
    const actualText = chainVal.replace(regex, '').replace('\n', ''); // remove any HTML tags and whitespace
    const containsActualText = !!chainVal && !!actualText && actualText?.length > 0;
    if (isValid && !!containsActualText) {
      return Promise.resolve(true);
    } else if (!isValid || !!!containsActualText) {
      return Promise.reject(new Error('Champs obligatoire'));
    } else {
      return Promise.resolve(false);
    }
  };


  let rules = [
    {
      required: data?.required || false,
      message: 'Champs obligatoire',
      validateTrigger: 'onSubmit'
    },
  ];

  if (data?.hiddenChain) {
    rules = [
      {
        required: data.required || false,
        validateTrigger: 'onSubmit',
        validator: customChainRule,
      },
    ];
  }

  return data && (isEdit || onlyRead) && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames} z
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={data?.displayLabel ? data?.label : data?.label}
        name={data?.name}
        className={
          data?.name + '-wrapper' + `${onlyRead ? ' only-read' : ''}`
        }
        rules={rules}
        initialValue={(method != newKey && !!!cameFrom || cameFrom == 'preview_communication') ? (currentValue || '') : ''}
      >
        <RichEditor
          placeholder={data?.placeholder || ''}
          content={(method != newKey && !!!cameFrom || cameFrom == 'preview_communication') ? (currentValue || '') : ''}
          handleChange={text => {
            
            form.setFieldsValue({
              [data?.name]: text,
            });
            if (data?.hiddenChain && text) {
              form.setFieldsValue({
                [data?.hiddenChain]: text,
              });
            }
            !!data?.onChange && data?.onChange(text);
          }}
          type={data?.type_editor || 'simple'}
        />
      </Form.Item>
    </Col>
  );
};

RichEditorField.defaultProps = {
  index: 1,
};

RichEditorField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
};

export default RichEditorField;